import { Controller } from "@hotwired/stimulus"

import { getOptions } from "../helpers/select2.js"

export default class extends Controller {
  static targets = [ "select" ]

  add_results(event) {
    
    event.preventDefault()
    let targetEl = event.currentTarget

    const params = { data: { term: null } }

    if (this.selectTargets.length > 0) {
      this.selectTargets.forEach((theSelect) => {
        let theSelectObj = $(theSelect)

        function success(data) {
          
          let template_id = theSelectObj.attr('id').replace('_select','_template')
          // for (let i = 0; i < count; i++) {
          // let id = `${new Date().valueOf()}${i}`
          let i = 0
          data.forEach((el) => {
            i+=1
            let id = `${new Date().valueOf()}${i}`
            let content_id = el.id
            let content = targetEl.dataset.template ? el[targetEl.dataset.template] : el.template_with_icon

            let template_content = document.getElementById(template_id).innerHTML
            template_content = template_content.replace(/TEMPLATE_CONTENT/g, content)
            template_content = template_content.replace(/TEMPLATE_ID/g, content_id)
            template_content = template_content.replace(/TEMPLATE_RECORD/g, id)

            if (template_content.includes('TEMPLATE_TEAM_ID')) {
              let team_el_id = theSelectObj.attr('id').replace('_players_select','_member_id')
              let team_id = $(document.getElementById(team_el_id)).val()
              template_content = template_content.replace(/TEMPLATE_TEAM_ID/g, team_id)
            }
            let ul_id = theSelectObj.attr('id').replace('_select','_ul')
            document.getElementById(ul_id).insertAdjacentHTML('beforeend', template_content)
          })
          
        }

        getOptions($(theSelect), params, success)
      })
    }

    setTimeout(()=> {
      $(document).Toasts('create', {
        autohide: true,
        position: 'bottomLeft',
        delay: 3000,
        title: targetEl.dataset.title,
        body: targetEl.dataset.message,
        class: 'bg-success'
      })
  
      $(targetEl).remove()
    }, 300)
  }

}
